import { User } from '@supabase/supabase-js';

export function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return "Bom dia";
  if (hour < 18) return "Boa tarde";
  return "Boa noite";
}

export function getUserDisplayName(user: User | null): string {
  if (!user) return "";
  const fullName = user.user_metadata?.full_name;
  if (fullName) {
    return fullName.split(" ")[0];
  }
  return user.email?.split("@")[0] || "";
}
